import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import Loader from '../../components/common/Loader';
import { Topbar } from '../../components/include/Topbar';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import DeleteModal from '../../components/common/DeleteModal';
import { message } from '../../redux/actions/toastActions';
import dayjs from 'dayjs';


const View_arts = () => {
    const [data, setData] = useState({});
    const [openMenuIndex, setOpenMenuIndex] = useState(false);
    const [loader, setLoader] = useState(false);
    const menuRefs = useRef({});
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState('');
    const dispatch = useDispatch();
    const params = useParams();
    const [selectedId, setSelectedId] = useState(null);
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);



    const toggleMenu = (index) => {
        setOpenMenuIndex(!openMenuIndex);
        // setOpenMenuIndex(true);
    };
    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.arts_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                navigate('/extracurricular', {
                    replace: true,
                    state: { currentTab: "Arts" },
                });
            }
            else {
                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.arts_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setData(res.data);
                if (res.data.image) {
                    setSelectedImage(res.data.image); // Set first image initially
                }
            }else{
                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }

    useEffect(() => {
        fetchData();
    }, [])
    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <>``
            <Topbar aerrow={true} currentTab="Arts" />
            <div className="mx-auto p-4">
                {selectedImage && (
                    <div className="mb-4">
                        <img
                            src={selectedImage}
                            alt="Selected"
                            className="w-full h-96 object-fill rounded-lg "
                        />
                    </div>
                )}
                <div className="bg-white rounded-xl p-4 relative flex justify-between text-gray-800   mx-auto">
                    <div>
                        <h3 className="text-md font-semibold mb-2">
                            {data.title}
                        </h3>
                        <h3 className="text-sm text-gray-400 font-normal ">
                            {dayjs(data.createdAt).format("DD MMM YYYY")}
                        </h3>
                        <h3 className="text-sm font-semibold mb-2">
                           {data.brief}
                        </h3>
                        <h3 className="text-sm font-normal mb-2">
                            {data.detailed}
                        </h3>

                    </div>
                    <div className='bg-white  '>
                        <div className="absolute top-3 right-3">
                            <button onClick={() => toggleMenu()}>
                                <img
                                    src={HiOutlineDotsVertical}
                                    className="text-black-500 hover:text-black"
                                />
                            </button>

                            {openMenuIndex && (
                                <div ref={(el) => (menuRefs.current = el)} className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                                    <button
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                        onClick={() => navigate(`/extracurricular/arts/edit/${data._id}`, { state: { type: "edit" } })}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => {
                                            setSelectedId(data._id);
                                            setmodalOpenDelete(true);
                                        }}
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                    >
                                        Delete
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
                <DeleteModal
                    title="Delete Art"
                    message="Are you sure you want to delete Art?
It will erase all the data permanently."
                    modalOpenDelete={modalOpenDelete}
                    setmodalOpenDelete={setmodalOpenDelete}
                    handleDelete={handleDelete} // Don't call it here
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                    setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                    module={"Arts"}
                    redirectPage={"Arts"}
                    redirectUrl={'/extracurricular'}
                />

            </div>

        </>
    )
}

export default View_arts